import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'clone';
import { Link } from 'react-router-dom';
import { Layout, Popover } from 'antd';
// import PubSub from 'pubsub-js';
import { Scrollbars } from 'react-custom-scrollbars';
import Menu from '../../components/uielements/menu';
import IntlMessages from '../../components/utility/intlMessages';

import {
  toggleOpenDrawer,
  changeOpenKeys,
  changeCurrent,
  toggleCollapsed,
} from '../../redux/app/reducer';
import Logo from '../../components/utility/logo';
import authAction from '../../redux/auth/actions';


const { logout } = authAction;
const { Sider } = Layout;

export class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);

    // if (props.app.view !== 'MobileView') {
    //   props.toggleOpenDrawer();
    // }

    let theCompany = null;
    if (props.companies) {
      theCompany = props.companies[0];
    }

    let errorState = false;
    let username = '';
    let userInitials = '';
    if (!props.userprofile.first_name) {
      errorState = true;
    } else {
      username = `${props.userprofile.first_name} ${props.userprofile.last_name}`;
      userInitials = props.userprofile.first_name.charAt(0) + props.userprofile.last_name.charAt(0);
    }

    this.state = {
      user: props.userprofile,
      username,
      userInitials,
      company: theCompany,
      errorState,
    };

    if (this.state.errorState === true) {
      console.warn('REFRESH DETECTED - LOGGING OUT');
      this.props.logout();
    }


//    PubSub.subscribe('user_loaded', this.myUserSubscriber);
//    PubSub.subscribe('company_loaded', this.mySubscriberComp);
  }


  componentDidMount() {
    this.isMountedComponent = true;
  }

  componentWillUnmount() {
    this.isMountedComponent = false;
  }


  onOpenChange(newOpenKeys) {
/* eslint-disable no-shadow */
    const { app, changeOpenKeys } = this.props;
/* eslint-enable */
    const latestOpenKey = newOpenKeys.find(key => !(app.openKeys.indexOf(key) > -1));
    const latestCloseKey = app.openKeys.find(key => !(newOpenKeys.indexOf(key) > -1));
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }

  getAncestorKeys = (key) => {
    const map = {
      sub3: ['sub2'],
    };
    return map[key] || [];
  }

  // myUserSubscriber(msg, data) {
  //   if (data === 'error') {
  //     // console.log('Error in Topbar ' + msg, data);
  //     this.props.logout();
  //     if (this.props.history) {
  //       this.props.history.push('/');
  //     }
  //   } else if (data && user.user && this.isMountedComponent) {
  //     this.setState({
  //       user,
  //       username: `${user.user.first_name} ${user.user.last_name}`,
  //       userInitials: user.user.first_name.charAt(0) + user.user.last_name.charAt(0),
  //     });
  //   }
  // }

  handleClick(e) {
    this.props.changeCurrent(e.key);
    // if (this.props.app.view === 'MobileView') {
    //   this.props.toggleCollapsed();
    //   this.props.toggleOpenDrawer();
    // }
  }

  logoutUser = () => {
    this.props.logout();
  };


  // mySubscriberComp = (msg, data) => {
  //   if (this.isMountedComponent) {
  //     this.forceUpdate();
  //   }
  // };

  helpPopupContent = (
    <div className="popover-style">
      <i className="ion-android-mail" />
      <a href="mailto:support@clearfronthr.com">support@clearfronthr.com</a>
      <hr />
      <i className="ion-android-call" />
      <a href="tel:1-833-437-4040">(833) 437-4040</a>
    </div>
  );

  logoutPopupContent = (
    <div className="popover-style">
      <i className="ion-power" />
      <Link to="/" onClick={this.logoutUser}>Logout</Link>
    </div>
  );

  render() {
    if (this.state.errorState === true || !this.state.user || !this.state.company) {
      return <h2>{}</h2>;
    }

    // const { url, app, toggleOpenDrawer, bgcolor } = this.props;
/* eslint-disable no-shadow */
    const { url, app } = this.props;
/* eslint-enable */
    const hidden = app.hidden;
    let width = 240;
    if (hidden) {
      width = 0;
      // return <h2> </h2>
    }
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const { openDrawer } = app;
    const mode = collapsed === true ? 'vertical' : 'inline';
    const onMouseEnter = () => {
      // if (openDrawer === false) {
      //   toggleOpenDrawer();
      // }
    };
    const onMouseLeave = () => {
      if (openDrawer === true) {
        // toggleOpenDrawer();
      }
    };
    const scrollheight = app.height;
    const styling = {
      backgroundColor: '#0f8aff',
    };

    const submenuColor = {
      color: 'rgba(255, 255, 255, 0.7)',
    };

    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={width}
        className="isomorphicSidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={styling}
      >
        <Logo />
        <Scrollbars style={{ height: scrollheight - 134 }}>
          <Menu
            defaultOpenKeys={['dashboard']}
            onClick={this.handleClick}
            theme="dark"
            mode={mode}
            // openKeys={app.openKeys}
            selectedKeys={[app.current]}
            onOpenChange={this.onOpenChange}
            className="isoDashboardMenu"
            inlineIndent={14}
          >

            {(this.state.company && this.state.company.onboarding === 0) &&
              <Menu.Item key="dashboard">
                <Link to={`${url}`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <img
                      style={{ paddingRight: 19, width: 38, height: 18 }}
                      alt="#"
                      src={`${process.env.PUBLIC_URL}/images/icons/icon_company_SVG.svg`}
                    />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.company" />
                    </span>
                  </span>
                </Link>
              </Menu.Item>
            }

            {(this.state.company && this.state.company.onboarding === 0) &&
              <Menu.Item key="workforce">
                <Link to={`${url}/workforce`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <img
                      style={{ paddingRight: 19, width: 38, height: 19 }}
                      alt="#"
                      src={`${process.env.PUBLIC_URL}/images/icons/Workforce.svg`}
                    />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.contacts" />
                    </span>
                  </span>
                </Link>
              </Menu.Item>
            }

            {(this.state.company && this.state.company.onboarding === 0) &&
              <Menu.Item key="invoice">
                <Link to={`${url}/invoice`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <img
                      style={{ paddingRight: 19, width: 38, height: 22 }}
                      alt="#"
                      src={`${process.env.PUBLIC_URL}/images/icons/Invoice.svg`}
                    />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.invoice" />
                    </span>
                  </span>
                </Link>
              </Menu.Item>
            }

            {this.state.user && this.state.user.goglobal_admin &&
              <Menu.Item key="admin_payments">
                <Link to={`${url}/admin/payments`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <img
                      style={{ paddingRight: 19, width: 38, height: 20 }}
                      alt="#"
                      src={`${process.env.PUBLIC_URL}/images/icons/icon_admin_SVG.svg`}
                    />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.admin_payments" />
                    </span>
                  </span>
                </Link>
              </Menu.Item>
            }

            {this.state.company && this.state.company.onboarding === 0 && <Menu.Divider />}
            <Popover
              placement="right"
              title="Need help?"
              content={this.helpPopupContent}
              trigger="click"
            >
              <div className="help-center">
                <span className="isoMenuHolder">
                  <i className="ion-help-circled" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.help_center" />
                  </span>
                </span>
              </div>
            </Popover>

            {/* <Menu.Item key="logout">
              <Link to={`${url}/`}>
                <span className="isoMenuHolder" style={submenuColor}>
                  <img style={{ paddingRight: 19, width: 38, height: 20 }}
                    alt="#" src={process.env.PUBLIC_URL + "/images/icons/Logout.svg"} />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.logout" />
                  </span>
                </span>
              </Link>
            </Menu.Item> */}

          </Menu>
        </Scrollbars>

        {!collapsed &&
          <div className="menu-footer">
            <div className="menu-footer-content">
              <div className="menu-name-monogram">
                <span>{this.state.userInitials}</span>
              </div>

              <span>{this.state.username}</span>

              <Popover
                placement="top"
                trigger="click"
                content={this.logoutPopupContent}
              >
                <div className="menu-footer-settings">
                  <i className="ion-ios-gear" />
                </div>
              </Popover>
            </div>
          </div>
        }
      </Sider>
    );
  }
}

// export default connect(
//   state => ({
//     app: state.App.toJS(),
//     //    customizedTheme: state.ThemeSwitcher.toJS().sidebarTheme
//   }),
//   {
//     logout, toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed,
//   },

// )(Sidebar);


/* eslint-disable no-shadow */
function mapStateToProps(state) {
  const { companies } = state.Company.toJS();
  const { contacts } = state.Contacts.toJS();
  const { userprofile } = state.Auth.toJS();
  const app = state.App.toJS();
  return {
    companies,
    contacts,
    userprofile,
    app,
  };
}
/* eslint-enable */
export default connect(
  mapStateToProps,
  {
    logout, toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed,
  },
)(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/Sidebar.js